import { CommonModule } from '@angular/common';
import {
	AfterContentInit,
	Component,
	ViewChild,
	ContentChild,
	ElementRef,
	Input,
	OnChanges,
	SimpleChanges,
	EventEmitter,
	Output,
} from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faTimes, faExpand, faCompress } from '@fortawesome/free-solid-svg-icons';

@Component({
	selector: 'cpi-modal',
	standalone: true,
	imports: [CommonModule, FontAwesomeModule],
	templateUrl: './modal.component.html',
	styleUrl: './modal.component.scss',
})
export class ModalComponent implements OnChanges {
	icons = {
		faTimes: faTimes,
		faExpand: faExpand,
		faCompress: faCompress,
	};

	isFullscreen = false;

	ngOnChanges(changes: SimpleChanges): void {
		if (changes && changes.isOpen) {
			if (this.isOpen == true) this.openModal();
			if (this.isOpen == false) this.closeModal();
		}
	}

	@Input()
	title = '';

	@Input()
	isOpen = false;
	@Input()
	showFooter = false;

	@Output()
	onModalClose = new EventEmitter();

	@Output()
	fullscreenChange = new EventEmitter<boolean>();

	public openModal(e?: Event): void {
		if (e && !(<HTMLElement>e.target).classList.contains('modal-background')) return;
		this.isOpen = true;
	}

	public closeModal(e?: Event): void {
		if (e && !(<HTMLElement>e.target).classList.contains('modal-background')) return;
		this.isOpen = false;
		this.isFullscreen = false;
		this.onModalClose.emit(true);
	}

	toggleFullscreen() {
		this.isFullscreen = !this.isFullscreen;

		// Emite o novo estado para o componente pai
		this.fullscreenChange.emit(this.isFullscreen);
	}
}
